import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { BoostAnchors } from '@bingads-webui-campaign-react/responsive-ad-editor-components';

const ValidatedAnchorAdInternal = ({
  validationProps,
  updateValidation,
}) => {
  const i18n = useContext(I18nContext);

  const { data = {} } = validationProps;

  const { BoostAnchors: BoostAnchorsData } = data;

  const onUpdate = (result) => {
    updateValidation([], { BoostAnchors: result });
  };

  return (
    <BoostAnchors
      i18n={i18n}
      defaultSelectedKey={BoostAnchorsData}
      onUpdate={onUpdate}
    />
  );
};

ValidatedAnchorAdInternal.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      BoostAnchors: PropTypes.string,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedAnchorAd = withCustomValidation(withUnvalidatedControlErrors(withControlErrorHandling(withError(ValidatedAnchorAdInternal))));

